import { Spacing } from 'UI'

const cardTypesImagesHeights = {
  1: 12,
  2: 24,
  7: 20,
  9: 24
}

export default theme => ({
  savedCardsRoot: {
    width: '100%'
  },
  savedCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 68,
    borderRadius: 8,
    marginBottom: 16,
    background: theme.neutral[400],
    border: `1px solid ${theme.neutral[300]}`,
    padding: () => Spacing(5)
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%'
  },
  removeCreditCardIcon: {
    cursor: 'pointer',
    color: theme.neutral[0],
    transition: 'color 0.2s ease-in-out',
    '&:hover': {
      color: theme.error[0]
    }
  },
  cardImage: {
    marginLeft: 8,
    height: card => cardTypesImagesHeights[card.PaymentMethodType]
  },
  cardNameClass: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
})
